export const ENTITY_ID_SEARCH_PARAM_KEY = 'entity_id';
export const REGISTER_ID_SEARCH_PARAM_KEY = 'register';
export const REGISTER_CLASS_ID_SEARCH_PARAM_KEY = 'register_class_id';
export const DATE_RANGE_SEARCH_PARAM_KEY = 'date_range';
export const DATE_FROM_SEARCH_PARAM_KEY = 'date_from';
export const DATE_TO_SEARCH_PARAM_KEY = 'date_to';
export const APPLY_REGISTER_PRIVATE_ID = 'apply_register_private_id';
export const APPLY_REGISTER_ID = 'apply_register_id';
export const APPLY_REGISTER_CLASS_ID = 'apply_register_class_id';
export const ENTITY_IS_VERIFIED_KEY = 'is_verified';
export const AUTH_TYPE_SEARCH_PARAM_KEY = 'auth_type';
export const SUBSCRIBE_FROM_PARAM_KEY = 'subscribe_from';
